/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_OrderInputs */

const en_orders_cancel_order = /** @type {(inputs: Orders_Cancel_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Order`)
};

const es_orders_cancel_order = /** @type {(inputs: Orders_Cancel_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar pedido`)
};

/**
* | output |
* | --- |
* | "Cancel Order" |
*
* @param {Orders_Cancel_OrderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_order = /** @type {((inputs?: Orders_Cancel_OrderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_OrderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_order(inputs)
	return es_orders_cancel_order(inputs)
});